import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 12px;
  background-color: ${({ theme }) => (theme as any).color.ui7 ?? '#fff'};
  border: 1px solid ${({ theme }) => (theme as any).color.ui5};
  box-shadow: ${({ theme }) => (theme as any).shadows?.outerShadow1 ?? '0 1px 4px rgba(0,0,0,.08)'};
  gap: 14px;
`;

export const NameContainer = styled.div`
  width: 100%;
  min-width: 0;

  /* EditableTitle: flex row, text truncates, icon on right */
  > div > div {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: 8px;
  }

  > div > div > div:has(input) {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  > div > div > i {
    flex-shrink: 0;
    margin-left: auto;
  }

  input,
  [contenteditable='true'] {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 0 8px 0 0;
    height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: transparent;
    border: none;
    outline: none;
    color: rgb(50, 53, 56);
    font-size: 20px;
    font-weight: 700;
    font-family: Poppins, sans-serif;
    line-height: 24px;
    letter-spacing: 0em;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const RowLabel = styled.div`
  width: 80px;
  min-width: 80px;
  ${({ theme }) => (theme as any).font.t2};
  color: ${({ theme }) => (theme as any).color.ui2};
  padding-top: 7px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ControlSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const InputRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const InputContainer = styled.div`
  input {
    width: 36px;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
`;

export const RegularLabel = styled.span`
  ${({ theme }) => (theme as any).font.t2};
  color: ${({ theme }) => (theme as any).color.ui2};
  flex-shrink: 0;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  background-color: ${({ theme }) => (theme as any).color.ui5};
  box-shadow: ${({ theme }) => (theme as any).shadows.outerShadow1};
`;

export const IconContainer = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  &:hover {
    svg {
      fill: ${({ theme }) => (theme as any).color.s2};
    }
  }
`;

export const AlignWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const SmallText = styled.span`
  ${({ theme }) => (theme as any).font.t4};
  color: ${({ theme }) => (theme as any).color.ui2};
`;
